import { PopperDelegate } from "./popper";
import { UiControlConstants } from "../../common/uicontrol-constants";

export class PopperHarnessController {
  public lists = [
    "Add Subscription",
    "Cancel Subscription",
    "Renew Subscription",
    "Review Subscription",
    "Add payment instrument",
    "Remove payment instrument"
  ];
  public popperDelegateObj: PopperDelegate;
  // @ngInject
  constructor(private $element: ng.IAugmentedJQuery, private uiControlConstants: UiControlConstants) {}

  public log(name: any) {
    console.log(name);
  }

  public closed() {
    console.log("popper closed");
  }

  public opened() {
    angular.element("ul.list-container li").first().focus();
  }

  public navigatePopper($event: any, item: any) {
    switch ($event.keyCode) {
      case this.uiControlConstants.keyCode.upArrowKeyCode:
        this.navigateToPreviousItem($event.target);
        break;
      case this.uiControlConstants.keyCode.downArrowKeyCode:
        this.navigateToNextItem($event.target);
        break;
      case this.uiControlConstants.keyCode.spaceKeyCode:
      case this.uiControlConstants.keyCode.enterKeyCode:
        this.log(item);
        this.popperDelegateObj.close();
        break;
      default:
        return;
    }

    $event.stopPropagation();
    $event.preventDefault();
  }

  public initialized(popperDelegateObj: PopperDelegate) {
    this.popperDelegateObj = popperDelegateObj;
  }

  public navigateToPreviousItem(target: any) {
    $(target).prevAll().first().focus();
  }

  public navigateToNextItem(target: any) {
    $(target).nextAll().first().focus();
  }
}
